import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Login } from '../views/unauthenticated/login/Login';
import { Register } from '../views/unauthenticated/register/Register';
import { SetNewPassword } from '@/components/views/unauthenticated/setNewPassword/SetNewPassword';
import { ResetPassword } from '@/components/views/unauthenticated/resetPassword/ResetPassword';
import { AppPaths } from '@/configs/appPaths';
import { EmailConfirmation } from '../views/common/EmailConfirmation';

export const UnauthenticatedApp: React.FC = () => {
	return (
		<Routes>
			<Route path={AppPaths.LOGIN} element={<Login />} />
			<Route path={AppPaths.REGISTER} element={<Register />} />
			<Route path={AppPaths.SET_PASSWORD} element={<SetNewPassword />} />
			<Route path={AppPaths.RESET_PASSWORD} element={<ResetPassword />} />

			<Route
				path={AppPaths.EMAIL_CONFIRMATION}
				element={<EmailConfirmation />}
			/>
			<Route path="*" element={<Navigate to={`/${AppPaths.LOGIN}`} />} />
		</Routes>
	);
};
